import React from 'react';
import {
  Typography,
  Box,
  List,
  ListItemText,
  ListItemIcon,
  IconButton,
  Button,
  TextField,
  InputAdornment,
} from '@mui/material';
import { FiStar, FiSearch, FiChevronRight } from 'react-icons/fi';
import { League } from '../../types';
import { LeagueItem } from '../../styles';

interface LeaguesListProps {
  leagues: League[];
  favorites: string[];
  toggleFavorite: (id: string) => void;
}

const LeaguesList: React.FC<LeaguesListProps> = ({
  leagues,
  favorites,
  toggleFavorite
}) => {
  return (
    <Box component="section" aria-label="Competições">
      <Typography variant="h6" gutterBottom>
        Principais competições
      </Typography>

      <TextField
        placeholder="Buscar liga..."
        size="small"
        fullWidth
        sx={{ mb: 2 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <FiSearch />
            </InputAdornment>
          ),
        }}
      />

      <List disablePadding>
        {leagues.map(league => (
          <LeagueItem key={league.id} disablePadding>
            <ListItemIcon>
              <img
                src={league.logo}
                alt={league.name}
                style={{ width: 24, height: 24 }}
                onError={(e: any) => { e.target.src = 'https://placehold.co/24' }}
              />
            </ListItemIcon>
            <ListItemText primary={league.name} secondary={league.country} />
            <IconButton
              edge="end"
              size="small"
              onClick={() => toggleFavorite(league.id)}
            >
              {favorites.includes(league.id)
                ? <FiStar fill="currentColor" />
                : <FiStar />
              }
            </IconButton>
          </LeagueItem>
        ))}
      </List>

      <Box textAlign="center" mt={2}>
        <Button
          variant="text"
          color="primary"
          endIcon={<FiChevronRight />}
        >
          Mostrar mais
        </Button>
      </Box>
    </Box>
  );
};

export default LeaguesList;